export const productionCostStartDate = new Date(2019, 0, 1);
export const productionCostStartYear = productionCostStartDate.getFullYear();

export const productionCostEndYear = new Date().getFullYear() + 10;
export const productionCostEndDate = new Date(productionCostEndYear, 11, 31);
